import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=1b9c54e5&scoped=true&"
import script from "./admin.js?vue&type=script&lang=js&"
export * from "./admin.js?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=1b9c54e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c54e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9c54e5')) {
      api.createRecord('1b9c54e5', component.options)
    } else {
      api.reload('1b9c54e5', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=1b9c54e5&scoped=true&", function () {
      api.rerender('1b9c54e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/admin.vue"
export default component.exports